import React, { useEffect, useState } from "react";
import { Modal } from "antd";
import axios from "axios";

const FarmEditor = ({ farmId, visible, onSuccess, onCancel }) => {
  const [farm, setFarm] = useState({
    name: "",
    code: "",
    address: ""
  });

  useEffect(() => {
    async function fetchData() {
      if (farmId) {
        try {
          const response = await axios.get(`/api/farms/${farmId}`, {
            headers: { Authorization: localStorage.getItem("token") },
          });
          const {name, code, address} = response.data.farm;
          setFarm({name, code, address});
        } catch (error) {
          console.log(error);
        }
      }
    }
    fetchData();
  }, []);

  const onFormSubmitted = async (event) => {
    event.preventDefault();
    if(!farmId){
      try{
        const response = await axios.post(`/api/farms`, farm,  {
          headers: { Authorization: localStorage.getItem("token") },
        });
        onSuccess(response.data);
      }catch(error){
        console.log(error);
      }
    }else{
      try{
        const response = await axios.put(`/api/farms/${farmId}`, farm,  {
          headers: { Authorization: localStorage.getItem("token") },
        });
        onSuccess(response.data);
      }catch(error){
        console.log(error);
      }
    }
    
    
  };

  const onFormFieldChanged = (event) => {
    setFarm({ ...farm, [event.target.name]: event.target.value });
  };

  return (
    <Modal visible={visible} onCancel={onCancel} footer={null} closable={false}>
      <div>
        <h2>{farmId ? "עדכון חווה" : "הוספת חווה חדשה"}</h2>
        <div>
          <form onSubmit={onFormSubmitted}>
            <div>
              <label htmlFor="name">שם החווה</label>
              <input
                type="text"
                name="name"
                value={farm.name}
                id="name"
                onChange={onFormFieldChanged}
              />
            </div>
            <div>
              <label htmlFor="code">קוד החווה</label>
              <input
                type="text"
                name="code"
                value={farm.code}
                id="code"
                onChange={onFormFieldChanged}
              />
            </div>
            <div>
              <label htmlFor="address">כתובת</label>
              <input
                type="text"
                name="address"
                value={farm.address}
                id="address"
                placeholder="http://127.0.0.1:85/ord"
                onChange={onFormFieldChanged}
              />
            </div>
            <br />
            <div>
              <input type="submit" value="שמירה" />
            </div>
          </form>
        </div>
      </div>
    </Modal>
  );
};

export default FarmEditor;
